module.exports = __webpack_public_path__ + "static/media/muli-latin-300.6e03d5eb.woff";